import { motion } from "framer-motion";
import { FaExpand } from "react-icons/fa";

export const ProductCard = ({ product, onClick, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group relative overflow-hidden rounded-2xl bg-surface border border-white/5 hover:border-gold-500/50 transition-all duration-500 cursor-pointer"
      onClick={onClick}
      data-testid={`product-card-${product.id}`}
    >
      {/* Image Container */}
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
        
        {/* View Button */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="p-4 rounded-full bg-gold-500/20 backdrop-blur-sm border border-gold-500/30">
            <FaExpand className="text-gold-400 text-xl" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <span className="inline-block px-3 py-1 text-xs font-medium text-gold-400 bg-gold-500/10 rounded-full mb-3 capitalize">
          {product.category}
        </span>
        <h3 className="font-heading text-xl text-white group-hover:text-gold-400 transition-colors duration-300">
          {product.name}
        </h3>
        <p className="mt-2 text-gray-400 text-sm line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          {product.description}
        </p>
      </div>

      {/* Glow Effect */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-t from-gold-500/10 to-transparent" />
      </div>
    </motion.div>
  );
};
